import { cn } from "@theprelude/core";

export const MicrosoftEntraIcon: React.FC<
  React.ComponentPropsWithoutRef<"svg">
> = ({ className, ...props }) => (
  <svg
    {...props}
    className={cn("size-4 flex-shrink-0", className)}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4306_7900)">
      <path
        d="M16.2114 8.75206L9.53679 0.992206C9.26981 0.680345 8.88713 0.524414 8.51335 0.524414C8.13957 0.524414 7.75689 0.680345 7.4899 0.992206L0.81525 8.75206C0.299077 9.34826 0.43257 10.2563 1.10004 10.6874C1.10004 10.6874 3.57411 12.2743 3.88559 12.4761L7.77469 14.9801C7.99718 15.1269 8.25526 15.1911 8.50445 15.1911V11.4579L4.62425 8.95385L8.50445 4.44103L12.3846 8.95385L8.49555 11.4579V15.1911C8.75364 15.1911 9.00282 15.1177 9.22531 14.9801L15.9 10.6783C16.5674 10.2472 16.7009 9.33909 16.1847 8.74288L16.2114 8.75206Z"
        fill="#1565C0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4306_7900">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
